import * as React from "react";

export interface PanelProps
{
	title: string
	hideTitle?: boolean;
}

export class Panel extends React.Component<PanelProps, any>
{
	render()
	{
		return <div className="panel panel-default">
			{this.renderTitle() }
			<div className="panel-body">
				{this.props.children}
			</div>
		</div>;
	}

	private renderTitle()
	{
		if (this.props.hideTitle)
			return null;

		return <div className="panel-heading">
			<h3 className="panel-title">{this.props.title}</h3>
		</div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/Panel.tsx